<template>
	<div class="page" v-loading="loading">
		<!-- 头部页面位置标记 -->
		<el-breadcrumb>
			<el-breadcrumb-item>商品管理</el-breadcrumb-item>
			<el-breadcrumb-item>商品价格</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 头部页面位置标记  end -->

		<!-- 搜索模块 -->
		<div class="search-module">
			<el-form :inline="true" class="demo-form-inline">
				<el-form-item>
					<el-input v-model="filter.keyword" placeholder="搜索商品名称/ID" size="mini" clearable>
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSearch" size="mini">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="success" size="mini" @click="onRefresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!-- 搜索模块 end -->

		<!-- 产品信息展示表格 -->
		<div class="table-module">
			<el-table :data="tableData" border style="width: 100%; margin-bottom: 20px;"
				:header-cell-style="{background:'#F5F5F5'}">
				<el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
				<el-table-column label="商品主图" width="100" align="center">
					<template v-slot="slotProps">
						<div class="product-main-container">
							<el-image :src="slotProps.row.thumb" style="width: 80px; height: 80px;" fit="contain">
							</el-image>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="商品信息" width="300" header-align="center">
					<template slot-scope="scope">
						<div class="product-info-container">
							<div>ID：{{ scope.row.good_no ? scope.row.good_no : '' }}</div>
							<div>{{ scope.row.title ? scope.row.title : '' }}</div>
							<div class="product-label-container">
								<div class="product-label-item">
									<el-tag class="tag" size="mini" effect="dark" v-for="(tag,i) in scope.row.tags"
										:key="i">
										{{ tag }}
									</el-tag>
								</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="original_price" label="原价" align="center">
					<template slot-scope="scope">
						<div>{{ scope.row.original_price ? scope.row.original_price : '' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="guide_price" label="官方指导价" align="center">
					<template slot-scope="scope">
						<div>{{ scope.row.guide_price ? scope.row.guide_price : '' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="sale_price" label="日常价" align="center">
					<template slot-scope="scope">
						<div>{{ scope.row.sale_price ? scope.row.sale_price : '' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="active_price" label="普通活动价" align="center">
					<template slot-scope="scope">
						<div>{{ scope.row.active_price ? scope.row.active_price : '' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="year_end_price" label="年终/大促" align="center">
					<template slot-scope="scope">
						<div>{{ scope.row.year_end_price ? scope.row.year_end_price : '' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="vip_agent_price" label="VIP代理" align="center">
					<template slot-scope="scope">
						<div>{{ scope.row.vip_agent_price ? scope.row.vip_agent_price : '' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="pt_agent_price" label="铂金代理" align="center">
					<template slot-scope="scope">
						<div>{{ scope.row.pt_agent_price ? scope.row.pt_agent_price : '' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="do_agent_price" label="钻石代理" align="center">
					<template slot-scope="scope">
						<div>{{ scope.row.do_agent_price ? scope.row.do_agent_price : '' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="three_stars_price" label="3星分销" align="center">
					<template slot-scope="scope">
						<div>{{ scope.row.three_stars_price ? scope.row.three_stars_price : '' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="four_stars_price" label="4星分销" align="center">
					<template slot-scope="scope">
						<div>{{ scope.row.four_stars_price ? scope.row.four_stars_price : '' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="five_stars_price" label="5星分销" align="center">
					<template slot-scope="scope">
						<div>{{ scope.row.five_stars_price ? scope.row.five_stars_price : '' }}</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 产品信息展示表格 end -->
	</div>
</template>

<script>
	export default {
		name: 'CommodityPrice',
		data() {
			return {
				loading: false,
				filter: {
					keyword: '',
				},
				actTableType: '0',
				tableData: [],
				counts: {},
				page: 1,
				maxpage: 1,
				total: 0,
			}
		},
		methods: {
			getData() {
				this.loading = true
				let data = this.filter
				data.page = this.page
				this.tableData = []
				this.$util.get('merchant/good/goods', data)
					.then(res => {
						this.loading = false
						console.log(res.data)
						this.tableData = res.data
						this.maxpage = res.last_page
						this.total = res.total
						this.counts = res.counts
						for (let i = 0; i < res.data.length; i++) {
							if (typeof res.data[i].tags == "string") {
								if (res.data[i].tags && res.data[i].tags.length > 0) {
									this.tableData[i].tags = this.tableData[i].tags.split(',')
								} else {
									this.tableData[i].tags = []
								}
							}
						}
					})
			},
			// 搜索按钮
			onSearch() {
				this.page = 1
				this.maxpage = 1
				this.total = 0
				this.tableData = []
				this.getData()
			},
			// 刷新按钮
			onRefresh() {
				this.getData()
			},
		},
		mounted() {
			this.getData()
		}
	}
</script>

<style lang="less" scoped>
	.page {}

	.search-module {
		margin-top: 20px;
	}

	.highlight-text {
		cursor: pointer;
		color: #4A94EB;
	}

	.table-module {
		/* margin-top: 10px; */
		width: 100%;
		max-width: 100%;
	}

	.product-info-container {
		.product-label-container {
			display: flex;
			flex-wrap: wrap;

			.product-label-item {
				margin-right: 5px;
				margin-top: 5px;

				.tag {
					margin-right: 10px;
				}
			}
		}
	}

	.product-main-container {
		height: 80px;
		width: 80px;
		text-align: center;
	}
</style>